import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { DELETE_PROMO_CODE_ACTION_TYPE, deletePromoCodeUrl, GET_PROMO_CODE_DETAILS_ACTION_TYPE, GET_PROMO_CODE_LIST_ACTION_TYPE, getPromoCodeDetailsUrl, getPromoCodeListUrl, headers, INSERT_PROMO_CODE_ACTION_TYPE, INSERT_UPDATE_PROMO_CODE_ACTION_TYPE, insertPromoCodeUrl, insertUpdatePromoCodeUrl, UPDATE_PROMO_CODE_ACTION_TYPE, updatePromoCodeUrl, } from "../../utils/constants"

export const get_promoCode_list_action = (CouponCode, disPer, expiry, status) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            CouponCode: CouponCode ? CouponCode : null,
            disPer: disPer ? disPer : null,
            expiry: expiry ? expiry : null,
            status: status ? status : 1
        }
        const res = await axiosGet(getPromoCodeListUrl, mapdata, headers);

        dispatch({
            type: GET_PROMO_CODE_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_promoCode_details_action = (PromoCodeID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            PromoCodeID: PromoCodeID
        }
        const res = await axiosGet(getPromoCodeDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_PROMO_CODE_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_promoCode_action = (Count, Discountpercent, ExpiryDate) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            Count: Count, Discountpercent: Discountpercent, ExpiryDate: ExpiryDate
        }

        console.log("share_credential_action res", mapdata)
        const res = await axiosPost(insertPromoCodeUrl, mapdata, headers);

        dispatch({
            type: INSERT_PROMO_CODE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const update_promoCode_action = (PromoCodeID, Discountpercent, ExpiryDate) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            PromoCodeID: PromoCodeID,
            Discountpercent: Discountpercent, ExpiryDate: ExpiryDate
        }
        console.log("share_credential_action res", mapdata)
        const res = await axiosPost(updatePromoCodeUrl, mapdata, headers);

        dispatch({
            type: UPDATE_PROMO_CODE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const delete_promoCode_action = (PromoCodeID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            PromoCodeID: PromoCodeID,
        }
        const res = await axiosGet(deletePromoCodeUrl, mapdata, headers);
        dispatch({
            type: DELETE_PROMO_CODE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};